export const appConfig = {
    tenant: 'staks',
};